import { _filter } from './filter'

/**
 * Return a new collection with any null (===) elements removed.
 */
export function _dropNull<T>(collection: Array<T | null>): T[];
export function _dropNull<T, L extends Lookup<T | null>>(collection: L): T[];
export function _dropNull<T>(collection: null | undefined): T[];
export function _dropNull<T>(collection: any): T[] {
	return _filter(collection, v => v !== null)
}

/**
 * Return a new collection with any undefined (===) elements removed.
 */
export function _dropUndefined<T>(collection: Array<T | undefined>): T[];
export function _dropUndefined<T, L extends Lookup<T | undefined>>(collection: L): T[];
export function _dropUndefined<T>(collection: null | undefined): T[];
export function _dropUndefined<T>(collection: any): T[] {
	return _filter(collection, v => v !== undefined)
}

/**
 * Return a new collection with any null or undefined elements removed.
 */
export function _dropEmpty<T>(collection: Array<T | null | undefined>): T[];
export function _dropEmpty<T, L extends Lookup<T | null | undefined>>(collection: L): T[];
export function _dropEmpty<T>(collection: null | undefined): T[];
export function _dropEmpty<T>(collection: any): T[] {
	return _filter(collection, v => v != null)
}

/**
 * Return a new collection with any falsy elements removed.
 */
export function _compact<T>(collection: Array<T | null | undefined | 0 | '' | false>): T[];
export function _compact<T, L extends Lookup<T | null | undefined | 0 | '' | false>>(collection: L): T[];
export function _compact<T>(collection: null | undefined): T[];
export function _compact<T>(collection: any): T[] {
	return _filter(collection, v => !!v)
}